export class IconConstructor {
  constructor() {
    this.namespaceURI = "http://www.w3.org/2000/svg";
    this.iconWidth = "25px";
    this.iconHeight = "26px";
    this.iconViewBox = "0 0 25 26";
  }

  getUserIcon(userHref) {
    const userIconPath = `M15.625 8C15.625 6.90625 15 5.89062 14.0625 5.30469C13.0859 4.75781 11.875 4.75781 10.9375 5.30469C9.96094 5.89062 9.375 6.90625 9.375 8C9.375 9.13281 9.96094 10.1484 10.9375 10.7344C11.875 11.2812 13.0859 11.2812 14.0625 10.7344C15 10.1484 15.625 9.13281 15.625 8ZM7.5 8C7.5 6.24219 8.4375 4.60156 10 3.70312C11.5234 2.80469 13.4375 2.80469 15 3.70312C16.5234 4.60156 17.5 6.24219 17.5 8C17.5 9.79688 16.5234 11.4375 15 12.3359C13.4375 13.2344 11.5234 13.2344 10 12.3359C8.4375 11.4375 7.5 9.79688 7.5 8ZM5.66406 21.125H19.2969C18.9453 18.6641 16.8359 16.75 14.2578 16.75H10.7031C8.125 16.75 6.01562 18.6641 5.66406 21.125ZM3.75 21.8672C3.75 18 6.83594 14.875 10.7031 14.875H14.2578C18.125 14.875 21.25 18 21.25 21.8672C21.25 22.4922 20.7031 23 20.0781 23H4.88281C4.25781 23 3.75 22.4922 3.75 21.8672Z`;
    return this._createIcon("user-icon", userHref, userIconPath);
  }

  getBasketIcon(basketHref, itemsQuantity, basketModal = null) {
    const basketIconPath = `M10.7422 3.11719C11.1719 3.35156 11.3672 3.9375 11.1328 4.40625L7.92969 10.5H17.0312L13.8281 4.40625C13.5938 3.9375 13.7891 3.35156 14.2188 3.11719C14.6875 2.88281 15.2734 3.07812 15.5078 3.50781L19.1406 10.5H20.5469H22.5H22.8125C23.3203 10.5 23.75 10.9297 23.75 11.4375C23.75 11.9844 23.3203 12.375 22.8125 12.375H22.0312L19.8438 21.125C19.5703 22.2188 18.5547 23 17.4219 23H7.57812C6.40625 23 5.42969 22.2188 5.11719 21.125L2.96875 12.375H2.1875C1.64062 12.375 1.25 11.9844 1.25 11.4375C1.25 10.9297 1.64062 10.5 2.1875 10.5H2.5H4.41406H5.82031L9.45312 3.50781C9.6875 3.07812 10.2734 2.88281 10.7422 3.11719ZM20.0781 12.375H4.88281L6.95312 20.6562C7.03125 20.9297 7.26562 21.125 7.57812 21.125H17.4219C17.6953 21.125 17.9297 20.9297 18.0078 20.6562L20.0781 12.375ZM6.875 14.5625C6.875 14.0547 7.26562 13.625 7.8125 13.625C8.32031 13.625 8.75 14.0547 8.75 14.5625C8.75 15.1094 8.32031 15.5 7.8125 15.5C7.26562 15.5 6.875 15.1094 6.875 14.5625ZM17.1875 13.625C17.6953 13.625 18.125 14.0547 18.125 14.5625C18.125 15.1094 17.6953 15.5 17.1875 15.5C16.6406 15.5 16.25 15.1094 16.25 14.5625C16.25 14.0547 16.6406 13.625 17.1875 13.625Z`;
    const basket = this._createIcon("basket-icon", basketHref, basketIconPath);
    basket.id = "basket-icon";
    this._appendItemQuantity(basket, itemsQuantity);
    let body = document.body;
    if (basketModal) {
      basket.onclick = function () {
        if (basketModal.style.display === "none") {
          body.classList.add("basketOpen");
          basketModal.style.display = "block";
        } else {
          body.classList.remove("basketOpen");
          basketModal.style.display = "none";
        }
      };
    }
    return basket;
  }

  _createIcon(name, href, path) {
    let iconWrapper = document.createElement("div");
    iconWrapper.classList.add("header__button-wrapper");
    let icon = document.createElement("a");
    if (href) {
      icon.href = href;
    }
    icon.classList.add(name);
    icon.setAttribute('target', '_blank');
    let basketIcon = this._createSVG(path);
    icon.append(basketIcon);
    iconWrapper.append(icon);
    return iconWrapper;
  }

  _createSVG(path) {
    let svgTag = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svgTag.setAttribute("width", this.iconWidth);
    svgTag.setAttribute("height", this.iconHeight);
    svgTag.setAttribute("viewBox", this.iconViewBox);
    svgTag.setAttribute("fill", "none");
    svgTag.setAttribute("version", "1.1");
    svgTag.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    svgTag.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
    svgTag.setAttribute("x", "0px");
    svgTag.setAttribute("y", "0px");
    svgTag.setAttribute("enable-background", "new 0 0 25 25");
    svgTag.setAttribute("xml:space", "preserve");
    svgTag.setAttribute("style", "cursor:pointer");
    let pathTag = this._createPath(path);
    svgTag.append(pathTag);
    return svgTag;
  }

  _createPath(path) {
    let path_tag = document.createElementNS(this.namespaceURI, "path");
    path_tag.setAttribute("d", path);
    path_tag.setAttribute("fill", "black");
    return path_tag;
  }

  _appendItemQuantity(basket, itemsQuantity) {
    if (itemsQuantity !== 0) {
      const itemQuantityContainer = document.createElement("div");
      itemQuantityContainer.classList.add("basket-icon__counter");
      itemQuantityContainer.id = "basket-quantity";
      const itemQuantityNumber = document.createElement("p");
      itemQuantityNumber.classList.add("counterValue");
      itemQuantityNumber.innerText = itemsQuantity;
      itemQuantityContainer.append(itemQuantityNumber);
      basket.append(itemQuantityContainer);
    }
  }

  refreshQuantity(itemQuantity) {
    const basket = document.getElementById("basket-icon");
    const quantity = document.getElementById("basket-quantity");
    if (quantity) {
      quantity.remove();
    }
    this._appendItemQuantity(basket, itemQuantity);
  }
}
